module.exports = __webpack_public_path__ + "img/Layer 2.7e36c565.svg";